import { render, staticRenderFns } from "./LogoDetail.vue?vue&type=template&id=73fa3c73&scoped=true"
import script from "./LogoDetail.vue?vue&type=script&lang=js"
export * from "./LogoDetail.vue?vue&type=script&lang=js"
import style0 from "./LogoDetail.vue?vue&type=style&index=0&id=73fa3c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa3c73",
  null
  
)

export default component.exports